export const encodeValue = (item) => {
    if (item === null || item === void 0 ? void 0 : item.iso2) {
        return `${item === null || item === void 0 ? void 0 : item.id}_${item === null || item === void 0 ? void 0 : item.iso2.toString()}`;
    }
    return `${item === null || item === void 0 ? void 0 : item.id}`;
};
export const decodeValue = (value) => {
    if (value === null || value === void 0 ? void 0 : value.includes('_')) {
        const [id, iso2] = value.split('_');
        return {
            id: parseInt(id),
            name: '',
            iso2: iso2 || null
        };
    }
    return {
        id: parseInt(value),
        name: '',
        iso2: null
    };
};
